export const getReminderVariant = (reminderDate: string): "success" | "warning" | "danger" => {
  const today = new Date();
  const reminder = new Date(reminderDate);
  const diffTime = reminder.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays > 5) return "success";
  if (diffDays > 2) return "warning";
  return "danger";
};

export const getDaysLeft = (dateString: string): string => {
  const today = new Date();
  const targetDate = new Date(dateString);
  const diffTime = targetDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays > 0) return `${diffDays} dni`;
  if (diffDays === 0) return "Dzisiaj";
  return `Po terminie (${Math.abs(diffDays)} dni temu)`;
}; 